export interface Customer_List_Interface {
  id:number,
  name:string,
  name_en:string,
  code:string,
  shenasehMeli:string,
  username:string,
  type:string,
  create_user:string,
  create_date:string,
  create_ip:string,
  update_user:string,
  update_date:string,
  update_ip:string,
  del:boolean,
  takhfif:number,
  DeletingProccess:boolean,
}

export function Empty_Customer_List_Interface():Customer_List_Interface{
  return{
    id:0,
    name:'',
    name_en:'',
    code:'',
    shenasehMeli:'',
    username:'',
    type:'',
    create_user:'',
    create_date:'',
    create_ip:'',
    update_user:'',
    update_date:'',
    update_ip:'',
    del: false,
    takhfif:0,
    DeletingProccess:false
  }
}
